import { requestGetReceiverSummary } from "@pages/dvtjcuv/service/DVTJCUVService";
import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { ServiceStatuses } from "@pages/candidate/detail/CandidateDVTJCUV";
import DVTJCUVPipelineTableList, { DVTJCUVPipelineListMode } from "@pages/dvtjcuv/list/DVTJCUVPipelineTableList";
import { MaxStepCddEmpProcess } from "@pages/dvtjcuv/common/Constant";

const DVTJCUVReceiverSummaryManager = (props) => {
    const [summary, setSummary] = useState({});

    const searchParams = new URLSearchParams(props.location.search)
    const recId = searchParams.get("recId")
    const cddId = searchParams.get("cddId")
    const fetchSummaryInfo = async () => {
        const res = await requestGetReceiverSummary({params: {rec_id: recId, cdd_id: cddId}})
        setSummary(res.content)
    }

    useEffect(() => {
        (async () => {
            await fetchSummaryInfo();
        })();
    },[])

    const displayId = () => {
        if (cddId) {
            return <div className="col-sm-3">
                Cdd ID:  <Link to={`/candidate/detail/${cddId}`} target="_blank"
                        rel="noopener noreferrer">{cddId}
                </Link>
            </div>
        }
        return <div className="col-sm-2">
            Rec ID:  <Link to={`/candidate/detail/${recId}`} target="_blank"
                    rel="noopener noreferrer"> {recId}
            </Link>
        </div>
    }

    const getUrl = (canId, receId, cddEmpProcesses) => {
        let url = ``
        if (canId) {
            url = `/dvtjcuv/list?cddId=${canId}&&cddEmpProcess=${cddEmpProcesses}&&unlimited=true&&mode=${DVTJCUVPipelineListMode.DVTJCUV_SEARCH_CDD_SUMMARY}`
        }
        if (receId) {
            url = `/dvtjcuv/list?recId=${receId}&&cddEmpProcess=${cddEmpProcesses}&&unlimited=true&&mode=${DVTJCUVPipelineListMode.DVTJCUV_SEARCH_REC_SUMMARY}`
        }
        return url
    }

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold w-100'>{recId ? 'Tổng hợp DVTJCUV theo Receiver' : 'Tổng hợp DVTJCUV theo Cdd'}</h3>
                    
                </div>
                <div className='card-body'>
                    <div className={'row mt-2'}>
                        {displayId()}
                        <div className="col-sm-2">{summary.displayed_full_name}</div>
                        <div className="col-sm-3">{summary.displayed_company}</div>
                        <div className="col-sm-2">{summary.displayed_title}</div>
                    </div>
                    {recId &&
                    <div className={'row mt-2'}>
                        <div className="col-sm-2">Nhận UV</div>
                        <div className="col-sm-2">{summary.pipe_created_date_time}</div>
                        <div className="col-sm-2">{summary.pipe_gp_emp_process}</div>
                    </div>
                    }
                    {cddId &&
                    <div className={'row mt-2'}>
                        <div className="col-sm-2">Acquire Cdd</div>
                        <div className="col-sm-2">{summary.pipe_created_date_time}</div>
                        <div className="col-sm-2">{summary.pipe_gp_cdd_process}</div>
                        <div className="col-sm-4">Trạng thái SDDV: {Object.values(ServiceStatuses).find(
                            item => item.id === summary.service_status)?.title}
                        </div>
                    </div>
                    }
                    <div className={'row mt-3'}>
                        <span target={'_blank'}
                            rel="noopener noreferrer"
                            className={'col-sm-12'}>
                                Step cao nhất: {summary.max_step}
                        </span>
                        <a href={getUrl(cddId, recId, ['Official Offer'])}
                            target={'_blank'}
                            rel="noopener noreferrer"
                            className={'col-sm-12'}>
                                Offer: {summary.offer_count}
                        </a>
                        <a href={getUrl(cddId, recId, `${MaxStepCddEmpProcess.VerbalOffer};${MaxStepCddEmpProcess.PreOfferProcedures}`)}
                            target={'_blank'}
                            rel="noopener noreferrer"
                            className={'col-sm-12'}>
                                Gần Offer: {summary.near_offer_count}
                        </a>
                        <a href={getUrl(cddId, recId, 'Interviewing;Interviewed (successful);Interviewed (not successful)')}
                            target={'_blank'}
                            rel="noopener noreferrer"
                            className={'col-sm-12'}>
                                Số ITV: {summary.itv_count}
                        </a>
                        <a href={getUrl(cddId, recId, "Cdd's CV sent")}
                            target={'_blank'}
                            rel="noopener noreferrer"
                            className={'col-sm-12'}>
                                Số CV sent: {summary.cv_sent_count}
                        </a>
                        <a href={getUrl(cddId, recId, "Brief sent")}
                            target={'_blank'}
                            rel="noopener noreferrer"
                            className={'col-sm-12'}>
                                Số Brief Sent: {summary.brief_sent_count}
                        </a>
                        
                        {/* <a href={`/dvtjcuv/list?recId=${recId}&&cddEmpProcess="Cdd's CV sent"`}
                            target={'_blank'}
                            rel="noopener noreferrer"
                            className={'col-sm-3'}>
                                Số Job: {summary.job_count}
                        </a> */}
                        
                        <a href={getUrl(cddId, recId, '') + '&&feedback=true'}
                            target={'_blank'}
                            rel="noopener noreferrer"
                            className={'col-sm-12'}>
                                Feedback: {summary.feedback_count}
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DVTJCUVReceiverSummaryManager;
